<template>
    <div class="chat-msg-item">
        <div class="chat-msg-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.RECALL || msgInfo.type == $enums.MESSAGE_TYPE.TIP_TEXT">{{ msgInfo.content }}</div>
        <div class="chat-msg-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TIME">{{ $date.toTimeText(msgInfo.sendTime) }}</div>
        <div class="chat-msg-normal" :class="{ 'chat-msg-mine': mine }">
            <div class="head-image">
                <el-avatar v-if="mine" :size="30" :src="normalizeUrl(myAvatarUrl)"></el-avatar>
                <el-avatar v-else :size="30" :src="normalizeUrl(avatarUrl)"></el-avatar>
            </div>
            <div class="chat-msg-content">
                <div class="chat-msg-top">
                    <span v-if="msgInfo.chatId < 0">{{ msgInfo.senderUserName || '-' }}</span>
                    <span>{{ $date.toTimeText(msgInfo.timestamp) }}</span>
                </div>
                <div class="chat-msg-bottom" @contextmenu.prevent="showRightMenu($event)">
                    <div ref="chatMsgBox" :class="{ 'chat-msg-box': msgInfo.text && msgInfo.type != 'text' }">
                        <!-- 文字 -->
                        <div class="chat-msg-text" v-if="msgInfo.type == 'text'">
                            <div style="padding: 6px 10px" v-html="htmlText" @click="onContentClick"></div>
                            <div v-if="showTranslate" v-loading="shouldShowAutoTranslateLoading" element-loading-background="rgba(255, 255, 255, .3)" class="chat-msg-text__translate">
                                <div style="padding: 6px 10px" v-if="msgInfo.translations && msgInfo.translations[targetLanguage]" v-html="msgInfo.translations[targetLanguage]" @click="onContentClick"></div>
                                <div style="padding: 6px 10px; color: #999;" v-else-if="!translateLoading && !shouldShowAutoTranslateLoading">翻译失败或暂无翻译内容</div>
                            </div>
                        </div>

                        <!-- 表情 -->
                        <div class="chat-msg-text" v-if="msgInfo.type == 'gif'">
                            <div style="padding: 6px 10px" v-html="htmlText" @click="onContentClick"></div>
                        </div>

                        <!-- 图片 -->
                        <div class="chat-msg-image" v-if="msgInfo.type == 'photo' || msgInfo.type == 'sticker'">
                            <div class="img-load-box" v-loading="loading" element-loading-text="上传中.." element-loading-background="rgba(0, 0, 0, 0.4)">
                                <img v-if="msgInfo.platform == 'facebook_api'" class="send-image" :src="`${msgInfo.fileUrl}`" @click="showFullImageBox(`${msgInfo.fileUrl}`)" loading="lazy" />
                                <img v-else class="send-image" :src="`${baseUrl}${msgInfo.fileUrl}`" @click="showFullImageBox(`${baseUrl}${msgInfo.fileUrl}`)" loading="lazy" />
                            </div>
                            <span title="发送失败" v-show="loadFail" @click="onSendFail" class="send-fail el-icon-warning"></span>
                        </div>
                        <!-- 视频 -->
                        <div class="chat-msg-image" v-else-if="msgInfo.type == 'video'">
                            <div class="img-load-box" v-loading="loading" element-loading-text="上传中.." element-loading-background="rgba(0, 0, 0, 0.4)">
                                <video v-if="msgInfo.platform == 'facebook_api'" class="send-image" :src="`${msgInfo.fileUrl}`" @click="showFullVideoBox(`${msgInfo.fileUrl}`)" controls loading="lazy" />
                                <video v-else class="send-image" :src="`${baseUrl}${msgInfo.fileUrl}`" @click="showFullVideoBox(`${baseUrl}${msgInfo.fileUrl}`)" controls loading="lazy" />
                            </div>
                            <span title="发送失败" v-show="loadFail" @click="onSendFail" class="send-fail el-icon-warning"></span>
                        </div>
                        <!-- 文件 -->
                        <div class="chat-msg-file" v-else-if="msgInfo.type == 'file'">
                            <div class="chat-file-box" v-loading="loading">
                                <div class="chat-file-info">
                                    <el-link class="chat-file-name" :underline="true" target="_blank" type="primary" :href="fileUrl" :download="getFileName(msgInfo.fileUrl)">{{ getFileName(msgInfo.fileUrl) }}</el-link>
                                </div>
                                <div class="chat-file-icon">
                                    <span type="primary" class="el-icon-document"></span>
                                </div>
                            </div>
                            <span title="发送失败" v-show="loadFail" @click="onSendFail" class="send-fail el-icon-warning"></span>
                        </div>
                    </div>

                    <div v-if="mine">
                        <img v-if="msgInfo.read" style="width: 16px;height: 16px;" src="../../assets/image/gougou.png" alt="">
                        <img v-else style="width: 16px;height: 16px;" src="../../assets/image/gougou2.png" alt="">
                    </div>
                    <!-- <div class="chat-receipt" v-show="msgInfo.receipt" @click="onShowReadedBox">
                        <span v-if="msgInfo.receiptOk" class="icon iconfont icon-ok" title="全体已读"></span>
                        <span v-else>{{ msgInfo.readedCount }}人已读</span>
                    </div> -->
                </div>
            </div>
        </div>
        <right-menu v-show="menu && rightMenu.show" :pos="rightMenu.pos" :items="menuItems" @close="rightMenu.show = false" @select="onSelectMenu"></right-menu>
        <chat-group-readed ref="chatGroupReadedBox" :msgInfo="msgInfo" :groupMembers="groupMembers"></chat-group-readed>
    </div>
</template>

<script>
    import RightMenu from '../common/RightMenu.vue';
    import ChatGroupReaded from './ChatGroupReaded.vue';
    import { normalizeUrl } from "@/utils/index";

    export default {
        name: 'messageItem',
        components: {
            RightMenu,
            ChatGroupReaded
        },
        props: {
            mode: {
                type: Number,
                default: 1
            },
            mine: {
                type: Boolean,
                required: true
            },
            showName: {
                type: String,
                required: true
            },
            msgInfo: {
                type: Object,
                required: true
            },
            groupMembers: {
                type: Array
            },
            menu: {
                type: Boolean,
                default: true
            },
            headImage: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                baseUrl: process.env.VUE_APP_BASE_URL,
                targetLanguage: 'zh',
                translateLoading: false,
                showTranslate: false,
                manualTranslate: false, // 标记是否为手动翻译
                autoTranslateTimeout: false, // 自动翻译是否超时
                autoTranslateTimer: null, // 自动翻译超时定时器
                rightMenu: {
                    show: false,
                    pos: {
                        x: 0,
                        y: 0
                    }
                }
            };
        },
        watch: {
            msgInfo: {
                handler(newVal) {
                    this.updateShowTranslate();
                },
                deep: true
            },
            'cicadeStore.activeChat': {
                handler(newChat, oldChat) {
                    // 切换聊天时，重置手动翻译标记
                    if (oldChat && newChat && oldChat.chatId !== newChat.chatId) {
                        this.manualTranslate = false;
                    }
                    this.updateShowTranslate();
                },
                deep: true
            }
        },
        created() {
            this.updateShowTranslate();
        },
        beforeDestroy() {
            // 清除定时器
            if (this.autoTranslateTimer) {
                clearTimeout(this.autoTranslateTimer);
                this.autoTranslateTimer = null;
            }
        },
        methods: {
            normalizeUrl,
            findChatById(chatId) {
                if (!chatId) return null;
                for (const group of this.cicadeStore.groupList) {
                    if (group.chats && group.chats.length > 0) {
                        const chat = group.chats.find(c => c.chatId === chatId);
                        if (chat) {
                            return chat;
                        }
                    }
                }
                return null;
            },
            // 获取当前聊天的自动翻译状态
            getAutoTranslateStatus() {
                const activeAccount = this.cicadeStore.activeAccount;
                if (!activeAccount || !this.cicadeStore.activeChat) {
                    return false;
                }
                if (activeAccount.channelName == 'customer') {
                    const chatStatus = this.findChatById(this.cicadeStore.activeChat?.chatId);
                    return chatStatus ? chatStatus.autoTranslate : false;
                } else {
                    return this.cicadeStore.activeChat?.autoTranslate || false;
                }
            },
            // 检查消息是否是历史消息
            isOldMessage() {
                // 获取消息时间戳（可能是秒级或毫秒级）
                let messageTime = 0;
                if (this.msgInfo.timestamp) {
                    // timestamp 可能是秒级，需要转换为毫秒
                    messageTime = this.msgInfo.timestamp > 1000000000000 
                        ? this.msgInfo.timestamp 
                        : this.msgInfo.timestamp * 1000;
                } else if (this.msgInfo.createTime) {
                    messageTime = this.msgInfo.createTime > 1000000000000 
                        ? this.msgInfo.createTime 
                        : this.msgInfo.createTime * 1000;
                } else {
                    // 如果没有时间戳，认为是新消息
                    return false;
                }
                // 如果消息创建时间距离现在超过3秒，认为是历史消息
                return Date.now() - messageTime > 3000;
            },
            // 更新翻译显示状态
            updateShowTranslate() {
                const hasTranslation = this.msgInfo.translations && this.msgInfo.translations[this.targetLanguage];
                const autoTranslateEnabled = this.getAutoTranslateStatus();
                
                // 如果有翻译数据，清除超时标记和定时器
                if (hasTranslation) {
                    this.clearAutoTranslateTimer();
                    this.autoTranslateTimeout = false;
                }
                
                // 显示翻译块的条件：
                // 1. 手动翻译
                // 2. 消息已有翻译数据（已翻译过的消息会一直显示）
                // 3. 自动翻译开启（即使还没有翻译数据，也会显示等待翻译）
                this.showTranslate = this.manualTranslate || hasTranslation || autoTranslateEnabled;
                
                // 如果是自动翻译模式且没有翻译数据
                if (!this.manualTranslate && autoTranslateEnabled && !hasTranslation) {
                    // 如果是历史消息，直接标记为超时，不显示loading
                    if (this.isOldMessage()) {
                        this.clearAutoTranslateTimer();
                        this.autoTranslateTimeout = true;
                    } else if (!this.autoTranslateTimeout) {
                        // 新消息且未超时，启动3秒超时定时器（避免重复创建）
                        if (!this.autoTranslateTimer) {
                            this.clearAutoTranslateTimer();
                            this.autoTranslateTimeout = false;
                            this.autoTranslateTimer = setTimeout(() => {
                                this.autoTranslateTimeout = true;
                                this.autoTranslateTimer = null;
                            }, 3000);
                        }
                    }
                } else {
                    this.clearAutoTranslateTimer();
                }
            },
            // 清除自动翻译定时器
            clearAutoTranslateTimer() {
                if (this.autoTranslateTimer) {
                    clearTimeout(this.autoTranslateTimer);
                    this.autoTranslateTimer = null;
                }
            },
            getFileName(url) {
                return url.split('/').pop();
            },
            onSendFail() {
                this.$message.error('该文件已发送失败，目前不支持自动重新发送，建议手动重新发送');
            },
            // 点击消息内容里的链接时，在新标签页打开
            onContentClick(e) {
                const anchor = e.target && e.target.closest && e.target.closest('a');
                if (anchor && anchor.href) {
                    e.preventDefault();
                    window.open(anchor.href, '_blank', 'noopener,noreferrer');
                }
            },
            showFullImageBox(url) {
                if (url) {
                    this.$store.commit('showFullImageBox', url);
                }
            },
            showFullVideoBox(url) {
                if (url) {
                    this.$store.commit('showFullVideoBox', url);
                }
            },
            showRightMenu(e) {
                this.rightMenu.pos = {
                    x: e.x,
                    y: e.y
                };
                this.rightMenu.show = 'true';
            },
            onSelectMenu(item) {
                if (item.key === 'TRANSLATE') {
                    if (this.showTranslate) {
                        // 关闭翻译时，重置手动翻译标记
                        this.manualTranslate = false;
                        this.showTranslate = false;
                        return;
                    }
                    // 手动翻译
                    this.translateMessage(false);
                } else if(item.key === 'NEXTTRANSLATE') { 
                    // 重新翻译
                    this.translateMessage(true);
                }
                else if(item.key === 'RECALL') {
                    this.$confirm("确定要撤回该消息吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$store.dispatch('recallMessage',{id:this.msgInfo.id,accountId:this.msgInfo.accountId});
                    })
                    .catch(() => {});
                } else {
                    this.$emit(item.key.toLowerCase(), this.msgInfo);
                }
            },
            onShowReadedBox() {
                let rect = this.$refs.chatMsgBox.getBoundingClientRect();
                this.$refs.chatGroupReadedBox.open(rect);
            },
            // 翻译消息的公共方法
            translateMessage(isAgain = false) {
                this.manualTranslate = true;
                this.showTranslate = true;
                this.translateLoading = true;
                this.$http({
                    url: '/client/translateMessage',
                    method: 'post',
                    params: {
                        accountId: this.$store.state.cicadeStore.activeAccount.accountId,
                        chatId: this.msgInfo.chatIdStr || this.msgInfo.chatId,
                        messageId: this.msgInfo.id,
                        targetLanguage: this.targetLanguage,
                        ...(isAgain && { isAgain: true })
                    }
                })
                .then((data) => {
                    let localMsgInfo = JSON.parse(JSON.stringify(this.msgInfo));
                    if (!localMsgInfo.translations) {
                        localMsgInfo.translations = {};
                    }
                    localMsgInfo.translations[this.targetLanguage] = data;
                    this.$store.dispatch('updateCicadeMessage', {
                        messageId: this.msgInfo.id,
                        message: localMsgInfo
                    });
                    this.translateLoading = false;
                })
                .catch((err) => {
                    this.$message.error('翻译失败!');
                    this.manualTranslate = false;
                    this.showTranslate = false;
                    this.translateLoading = false;
                });
            }
        },
        computed: {
            cicadeStore() {
                return this.$store.state.cicadeStore;
            },
            loading() {
                return this.msgInfo.loadStatus && this.msgInfo.loadStatus === 'loading';
            },
            loadFail() {
                return this.msgInfo.loadStatus && this.msgInfo.loadStatus === 'fail';
            },
            fileUrl() {
                return this.msgInfo.platform == 'facebook_api' 
                    ? this.msgInfo.fileUrl 
                    : `${this.baseUrl}${this.msgInfo.fileUrl}`;
            },
            menuItems() {
                let items = [];
                if (this.msgInfo.text) {
                    items.push({
                        key: 'TRANSLATE',
                        name: this.showTranslate ? '原文' : '翻译',
                        icon: 'el-icon-magic-stick'
                    });
                }

                if (this.msgInfo.text && this.showTranslate) {
                    items.push({
                        key: 'NEXTTRANSLATE',
                        name: '重新翻译',
                        icon: 'el-icon-refresh-left'
                    });
                }

                if (this.msgInfo.senderId == this.msgInfo.accountId) {
                    items.push({
                        key: 'RECALL',
                        name: '撤回',
                        icon: 'el-icon-refresh-left'
                    });
                }
                return items;
            },
            // 判断是否是自动翻译模式（非手动翻译且自动翻译开启）
            isAutoTranslateMode() {
                return !this.manualTranslate && this.getAutoTranslateStatus();
            },
            // 判断是否有翻译数据
            hasTranslation() {
                return this.msgInfo.translations && this.msgInfo.translations[this.targetLanguage];
            },
            // 判断是否应该显示自动翻译loading
            shouldShowAutoTranslateLoading() {
                // 手动翻译时，使用 translateLoading
                if (this.manualTranslate) {
                    return this.translateLoading;
                }
                // 自动翻译模式：只有在没有翻译数据且未超时时才显示loading
                if (this.isAutoTranslateMode && !this.hasTranslation) {
                    // 如果是历史消息，直接不显示loading
                    if (this.isOldMessage()) {
                        return false;
                    }
                    // 新消息：未超时时显示loading
                    return !this.autoTranslateTimeout;
                }
                return false;
            },
            // 安全获取自己头像 URL
            myAvatarUrl() {
                // 如果提供了 headImage prop（历史记录模式），优先使用
                if (this.headImage) {
                    // 判断是否是完整 URL
                    if (this.headImage.startsWith('http://') || this.headImage.startsWith('https://')) {
                        return this.headImage;
                    }
                    return this.headImage ? `${this.baseUrl}${this.headImage}` : '';
                }
                const userInfo = this.$store.state.userStore?.userInfo;
                const headImageThumb = userInfo?.headImageThumb || '';
                // 判断是否是完整 URL
                if (headImageThumb && (headImageThumb.startsWith('http://') || headImageThumb.startsWith('https://'))) {
                    return headImageThumb;
                }
                return headImageThumb;
            },
            // 安全获取对方头像 URL
            avatarUrl() {
                // 如果提供了 headImage prop（历史记录模式），优先使用
                if (this.headImage) {
                    // 判断是否是完整 URL
                    if (this.headImage.startsWith('http://') || this.headImage.startsWith('https://')) {
                        return this.headImage;
                    }
                    return this.headImage ? `${this.baseUrl}${this.headImage}` : '';
                }
                // 优先使用 activeChat 的头像
                if (this.cicadeStore.activeChat?.avatar) {
                    return `${this.baseUrl}${this.cicadeStore.activeChat.avatar}`;
                }
                // 如果 activeChat 没有头像，尝试从 groupList 中查找
                if (this.cicadeStore.activeChat?.chatId) {
                    const chat = this.findChatById(this.cicadeStore.activeChat.chatId);
                    if (chat?.avatar) {
                        return `${this.baseUrl}${chat.avatar}`;
                    }
                }
                return '';
            },
            htmlText() {
                const msg = this.msgInfo;
                const color = msg.selfSend ? 'white' : '';
                const text = msg.text || msg.fileUrl || '';

                if (
                    msg.type === 'text' || 
                    (msg.type === 'gif' && /\p{Extended_Pictographic}/u.test(text))
                ) {
                    let html = this.$url.replaceURLWithHTMLLinks(text, color);
                    return this.$emo.transform(html);
                }

                if (
                    (msg.type === 'gif' || msg.type === 'image') &&
                    msg.fileUrl &&
                    !/\p{Extended_Pictographic}/u.test(msg.fileUrl) &&
                    !msg.fileUrl.endsWith('.tgs')
                ) {
                    return `<img src="${this.baseUrl}${msg.fileUrl}" alt="${msg.type}" />`;
                }

                if (msg.type === 'gif' && msg.fileUrl && msg.fileUrl.endsWith('.tgs')) {
                    return `
                        <lottie-player
                            src="${this.baseUrl}${msg.fileUrl}"
                            background="transparent"
                            speed="1"
                            loop
                            autoplay
                            style="width: 100px; height: 100px;">
                        </lottie-player>
                    `;
                }

                return '';
            }

        }
    };
</script>

<style lang="scss">
    .chat-msg-item {
        .chat-msg-tip {
            line-height: 50px;
            font-size: var(--im-font-size-small);
            color: var(--im-text-color-light);
        }

        .chat-msg-normal {
            position: relative;
            font-size: 0;
            padding-left: 48px;
            min-height: 50px;
            margin-top: 10px;

            .head-image {
                position: absolute;
                width: 40px;
                height: 40px;
                top: 0;
                left: 0;
            }

            .chat-msg-content {
                text-align: left;

                .send-fail {
                    color: #e60c0c;
                    font-size: 30px;
                    cursor: pointer;
                    margin: 0 20px;
                }

                .chat-msg-top {
                    display: flex;
                    flex-wrap: nowrap;
                    color: var(--im-text-color-light);
                    font-size: var(--im-font-size);
                    line-height: 20px;

                    span {
                        margin-right: 12px;
                    }
                }

                .chat-msg-bottom {
                    display: inline-block;
                    padding-right: 300px;
                    padding-left: 5px;

                    .chat-msg-box {
                        background-color: var(--im-background);
                    }

                    .chat-msg-text {
                        display: block;
                        position: relative;
                        line-height: 26px;
                        //margin-top: 3px;
                        background-color: var(--im-background);
                        border-radius: 10px;
                        font-size: var(--im-font-size);
                        text-align: left;
                        white-space: pre-wrap;
                        word-break: break-all;

                        &:after {
                            content: '';
                            position: absolute;
                            left: -10px;
                            top: 13px;
                            width: 0;
                            height: 0;
                            border-style: solid dashed dashed;
                            border-color: #eee transparent transparent;
                            overflow: hidden;
                            border-width: 10px;
                        }

                        .chat-msg-text__translate {
                            // display: none;
                            min-height: 30px;
                            margin-top: 8px;
                            padding-top: 8px;
                            border-top: 1px solid rgba(204, 204, 204, 0.6);
                        }
                    }

                    .chat-msg-image {
                        display: flex;
                        flex-wrap: nowrap;
                        flex-direction: row;
                        align-items: center;

                        .send-image {
                            height: 100%;
                            width: 100%;
                            // min-width: 200px;
                            // min-height: 150px;
                            max-width: 400px;
                            max-height: 300px;
                            border-radius: 8px;
                            cursor: pointer;
                        }
                    }

                    .chat-msg-file {
                        display: flex;
                        flex-wrap: nowrap;
                        flex-direction: row;
                        align-items: center;
                        cursor: pointer;
                        margin-bottom: 2px;

                        .chat-file-box {
                            display: flex;
                            flex-wrap: nowrap;
                            align-items: center;
                            min-height: 60px;
                            box-shadow: var(--im-box-shadow-light);
                            border-radius: 4px;
                            padding: 10px 15px;

                            .chat-file-info {
                                flex: 1;
                                height: 100%;
                                text-align: left;
                                font-size: 14px;
                                margin-right: 10px;

                                .chat-file-name {
                                    display: inline-block;
                                    width: 100%;
                                    // min-width: 160px;
                                    max-width: 220px;
                                    font-size: 14px;
                                    margin-bottom: 4px;
                                    white-space: pre-wrap;
                                    word-break: break-all;
                                }

                                .chat-file-size {
                                    font-size: var(--im-font-size-smaller);
                                    color: var(--im-text-color-light);
                                }
                            }

                            .chat-file-icon {
                                font-size: 44px;
                                color: #d42e07;
                            }
                        }

                        .send-fail {
                            color: #e60c0c;
                            font-size: 30px;
                            cursor: pointer;
                            margin: 0 20px;
                        }
                    }

                    .chat-msg-voice {
                        font-size: 14px;
                        cursor: pointer;

                        audio {
                            height: 45px;
                            padding: 5px 0;
                        }
                    }

                    .chat-action {
                        display: flex;
                        align-items: center;

                        .iconfont {
                            cursor: pointer;
                            font-size: 22px;
                            padding-right: 8px;
                        }
                    }

                    .chat-msg-status {
                        display: block;

                        .chat-readed {
                            font-size: 12px;
                            color: var(--im-text-color-light);
                        }

                        .chat-unread {
                            font-size: var(--im-font-size-smaller);
                            color: var(--im-color-danger);
                        }
                    }

                    .chat-receipt {
                        font-size: var(--im-font-size-smaller);
                        cursor: pointer;
                        color: var(--im-text-color-light);

                        .icon-ok {
                            font-size: 20px;
                            color: var(--im-color-sucess);
                        }
                    }

                    .chat-at-user {
                        padding: 2px 5px;
                        border-radius: 3px;
                        cursor: pointer;
                    }
                }
            }

            &.chat-msg-mine {
                text-align: right;
                padding-left: 0;
                padding-right: 48px;

                .head-image {
                    left: auto;
                    right: 0;
                }

                .chat-msg-content {
                    text-align: right;

                    .chat-msg-top {
                        flex-direction: row-reverse;

                        span {
                            margin-left: 12px;
                            margin-right: 0;
                        }
                    }

                    .chat-msg-bottom {
                        padding-left: 180px;
                        padding-right: 5px;

                        .chat-msg-text {
                            margin-left: 10px;
                            background-color: var(--im-bubble-background);
                            color: #000;

                            &:after {
                                left: auto;
                                right: -10px;
                                border-top-color: var(--im-bubble-background);
                            }
                        }

                        .chat-msg-image {
                            flex-direction: row-reverse;
                        }

                        .chat-msg-file {
                            flex-direction: row-reverse;
                        }

                        .chat-action {
                            flex-direction: row-reverse;

                            .iconfont {
                                transform: rotateY(180deg);
                            }
                        }
                    }
                }
            }
        }
    }
</style>
